module.exports = __webpack_public_path__ + "678000f65c4041601ac0319b1f0e70b8.png";